import * as actions from "./actionsTypes";

const initialData = {
  loaderApproaches: false,
  approaches: null,
  approachesFail: null,
  saveLoaderApproaches: false,
  approachesFormError: null,
};

export default function ApproachesReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_APPROACHES:
      return { ...state, loaderApproaches: action.payload };

    case actions.GET_APPROACHES:
      return { ...state, approaches: action.payload };

    case actions.APPROACHES_FAIL:
      return { ...state, approachesFail: action.payload };

    case actions.SAVE_LOADER_APPROACHES:
      return { ...state, saveLoaderApproaches: action.payload };

    case actions.FORM_APPROACHES_FAIL:
      return { ...state, approachesFormError: action.payload };

    default:
      return state;
  }
}
